var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { AuthStateModel } from './auth.state.model';
import { LoginWithBiodigital, LoginSuccess, LoginFailure, GetUserProfile, Logout, LogoutSuccess, IsLoggedIn, IsLoggedInSuccess, IsLoggedInFailure, GetUserProfileSuccess, GetUserProfileFailure, CheckSession, CheckProfile, CheckProfileSuccess, CheckProfileFailure, GetEnvironmentSettings, GetEnvironmentSettingsSuccess, GetEnvironmentSettingsFailure, ResetPassword, ResetPasswordSuccess, ResetPasswordFailure, SignUp, SignUpSuccess, SignUpFailure, LoginWithGoogle, LoginWithFacebook, SetUserLocale, SetUserLocaleSuccess, CheckLocale, GetUserApps, SetSelectedUserApp, SetUserApps, CheckSelectedUserApp, SetUserMessageViewed, SetUserMessageViewedSuccess, SetUserMessageViewedFail, ResetAuth, GetUserMessage, GetUserMessageFail, GetUserMessageSuccess, LogoutFailure } from './auth.actions';
import { AuthService } from '../../auth.service';
import { SetOrganizations, ResetOrganizations } from 'src/app/organizations/state/organizations.actions';
import { finalize } from 'rxjs/operators';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { locales, defaultLocale } from 'src/app/locale-config.module';
import { ResetBookmarks } from 'src/app/bookmarks/state/bookmarks.actions';
import { ResetEditPage } from 'src/app/edit/state/edit.actions';
import { ResetEnginePosition } from 'src/app/engine/state/engine.actions';
import { ResetExplore } from 'src/app/explore/state/explore.actions';
import { ResetHistory } from 'src/app/history/state/history.actions';
import { ResetLabels } from 'src/app/story/state/labels/story.labels.actions';
import { ResetStory } from 'src/app/story/state/story.actions';
import { ResetStoryChapters } from 'src/app/story/state/chapters/story.chapters.actions';
import { ResetView } from 'src/app/classic-view/state/classic-view.actions';
import { ResetLayout } from 'src/app/layout/state/layout.actions';
import { ResetEngineNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { UserMessageService } from 'src/app/shared/user-message.service';
import { ErrorService, ErrorMessage } from 'src/app/shared/error.service';
import { get } from 'lodash';
import { GalleryActions } from 'src/app/gallery/state/gallery.actions';
const initialState = {
    loading: false,
    loggedIn: null,
    userLocale: null
};
let AuthState = class AuthState {
    constructor(authService, userMessageService, storageService, localeId, store, errorService) {
        this.authService = authService;
        this.userMessageService = userMessageService;
        this.storageService = storageService;
        this.localeId = localeId;
        this.store = store;
        this.errorService = errorService;
    }
    /**
     * Selectors
     */
    static getLoggedIn(state) {
        return state.loggedIn;
    }
    static getEnvironmentSettings(state) {
        return state.environmentSettings;
    }
    static getUserProfile(state) {
        return state.userProfile;
    }
    static getProfileCheck(state) {
        return state.profileCheck;
    }
    static getLoading(state) {
        return state.loading;
    }
    static getUserLocale(state) {
        return state.userLocale;
    }
    static getUserLanguage(state) {
        return get(state, 'userLocale.lang', defaultLocale.lang);
    }
    static getUserApps(state) {
        return get(state, 'userApps', []);
    }
    static getSelectedUserApp(state) {
        const apps = state.userApps || [];
        return apps.find((app) => app.id === state.selectedAppId);
    }
    static isPremiumUser(state) {
        return get(state, 'userProfile.premium_account_valid') === true;
    }
    /**
     * Actions
     */
    isLoggedIn(context, action) {
        context.patchState({ loading: true });
        this.authService.isLoggedIn()
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe((result) => {
            if (result.signed_in) {
                context.dispatch(new IsLoggedInSuccess());
            }
            else {
                context.dispatch(new IsLoggedInFailure());
            }
        });
    }
    isLoggedInSuccess(context, action) {
        context.patchState({
            loggedIn: true
        });
    }
    isLoggedInFailure(context, action) {
        context.patchState({
            loggedIn: false
        });
    }
    login(context, action) {
        context.patchState({ loading: true });
        this.authService.loginWithBiodigital(action.login)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => {
            context.dispatch(new LoginSuccess());
        }, (error) => {
            this.logFailure('LOGIN_FAILURE', error);
            context.dispatch(new LoginFailure(error, action.login));
        });
    }
    loginWithGoogle(context, action) {
        context.patchState({ loading: true });
        this.authService.loginWithGoogle(action.login)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => {
            context.dispatch(new LoginSuccess());
        }, (error) => {
            if (action.login.groupCodeMode === 1 || action.login.groupInviteMode === 1) {
                this.logFailure('GOOGLE_SIGNUP_FAILURE', error);
            }
            context.dispatch(new LoginFailure(error, action.login));
        });
    }
    // Deprecated
    loginWithFacebook(context, action) {
        context.patchState({ loading: true });
        this.authService.loginWithFacebook(action.login)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => {
            context.dispatch(new LoginSuccess());
        }, (error) => {
            context.dispatch(new LoginFailure(error, action.login));
        });
    }
    loginSuccess(context, action) {
        context.dispatch(new IsLoggedIn());
        context.dispatch(new CheckLocale());
    }
    logout(context, action) {
        context.patchState({ loading: true });
        this.authService.logout()
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => context.dispatch(new LogoutSuccess()), () => context.dispatch(new LogoutFailure()));
    }
    logoutSuccess(context, action) {
        context.setState(initialState);
        context.dispatch(new ResetAuth());
        context.dispatch(new ResetBookmarks());
        context.dispatch(new ResetEditPage());
        context.dispatch(new ResetEnginePosition());
        context.dispatch(new ResetEngineNodes());
        context.dispatch(new ResetExplore());
        context.dispatch(new ResetHistory());
        context.dispatch(new ResetLabels());
        context.dispatch(new ResetLayout());
        context.dispatch(new ResetOrganizations());
        context.dispatch(new ResetStory());
        context.dispatch(new ResetStoryChapters());
        context.dispatch(new ResetView());
        context.dispatch(new GalleryActions.Reset());
        // clear cached storage
        this.storageService.clearSessionStorage();
    }
    checkProfile(context, action) {
        context.patchState({ loading: true });
        return this.authService.checkProfile(action.email)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe((profile) => {
            context.dispatch(new CheckProfileSuccess(profile));
        }, (error) => {
            context.dispatch(new CheckProfileFailure(error));
        });
    }
    checkProfileSuccess(context, action) {
        context.patchState({
            profileCheck: action.profile
        });
    }
    getUserProfile(context, action) {
        context.patchState({ loading: true });
        return this.authService.getUserProfile()
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe((userProfile) => {
            context.dispatch(new GetUserProfileSuccess(userProfile));
        }, (error) => {
            context.dispatch(new GetUserProfileFailure(error));
        });
    }
    getUserProfileSuccess(context, action) {
        context.patchState({
            userProfile: action.userProfile
        });
        context.dispatch(new SetOrganizations(action.userProfile.organizations));
        context.dispatch(new GetUserApps());
        context.dispatch(new CheckLocale());
    }
    getUserApps(context, action) {
        this.authService.getUserApps()
            .subscribe((apps) => {
            context.dispatch(new SetUserApps(apps));
            context.dispatch(new CheckSelectedUserApp());
        }, 
        // #TODO: handle errors
        (err) => {
        });
    }
    setUserApps(context, { apps }) {
        context.patchState({
            userApps: apps
        });
    }
    setSelectedUserApp(context, { appId }) {
        context.patchState({
            selectedAppId: appId
        });
        // update storage
        if (appId !== null) {
            this.storageService.setLocalItem(StorageItemEnum.UserAppId, appId);
        }
        else {
            this.storageService.removeLocalItem(StorageItemEnum.UserAppId);
        }
    }
    checkSelectedUserApp(context, action) {
        const apps = context.getState().userApps;
        const storedAppId = this.storageService.getLocalItem(StorageItemEnum.UserAppId);
        if (storedAppId) { // set stored app
            const appId = parseInt(storedAppId, 10);
            context.dispatch(new SetSelectedUserApp(appId));
        }
        else if (apps && apps.length) { // set default app
            context.dispatch(new SetSelectedUserApp(apps[0].id));
        }
    }
    checkSession(context, action) {
        context.patchState({ loading: true });
        this.authService.isLoggedIn()
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe((result) => {
            if (result.signed_in) {
                context.dispatch(new IsLoggedInSuccess());
                context.dispatch(new GetUserProfile());
            }
            else {
                context.dispatch(new IsLoggedInFailure());
            }
        });
    }
    getEnvironmentSettings(context, action) {
        context.patchState({ loading: true });
        return this.authService.getEnvironmentSettings()
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe((environmentSettings) => {
            context.dispatch(new GetEnvironmentSettingsSuccess(environmentSettings));
        }, (error) => {
            context.dispatch(new GetEnvironmentSettingsFailure(error));
        });
    }
    GetEnvironmentSettingsSuccess(context, action) {
        context.patchState({
            environmentSettings: action.environmentSettings
        });
    }
    resetPassword(context, action) {
        context.patchState({ loading: true });
        this.authService.resetPassword(action.email)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => {
            context.dispatch(new ResetPasswordSuccess(action.email));
        }, (error) => {
            context.dispatch(new ResetPasswordFailure(error));
        });
    }
    signUp(context, action) {
        context.patchState({ loading: true });
        return this.authService.signUp(action.value)
            .pipe(finalize(() => context.patchState({ loading: false })))
            .subscribe(() => {
            context.dispatch(new SignUpSuccess());
        }, (error) => {
            context.dispatch(new SignUpFailure(error));
        });
    }
    signUpFailure(context, action) {
        this.logFailure('BIODIGITAL_SIGNUP_FAILURE', action);
    }
    setUserLocale(context, { locale }) {
        // set storage
        this.storageService.setLocalItem(StorageItemEnum.Locale, locale.id);
        context.patchState({ userLocale: locale });
        context.dispatch(new SetUserLocaleSuccess(locale));
    }
    checkLocale(context, action) {
        const targetLocale = locales.find((locale) => locale.id === this.localeId) || defaultLocale;
        context.dispatch(new SetUserLocale(targetLocale));
    }
    getUserMessage(context, { type, mode }) {
        this.userMessageService.getUserMessage(type, mode)
            .subscribe((message) => {
            context.dispatch(new GetUserMessageSuccess(message));
        }, () => {
            context.dispatch(new GetUserMessageFail(type));
        });
    }
    setUserMessageViewed(context, { messageSeenId }) {
        this.userMessageService.setUserMessageViewed(messageSeenId)
            .subscribe(() => context.dispatch(new SetUserMessageViewedSuccess()), () => context.dispatch(new SetUserMessageViewedFail()));
    }
    resetAuth(context, action) {
        context.setState(initialState);
    }
    logFailure(category, error) {
        const message = get(error, 'message') || '';
        const log = get(error, 'error.error.message') || '';
        this.errorService.logError(new ErrorMessage(category, message, log)).subscribe();
    }
    ngxsOnInit(context) {
        context.dispatch(new CheckSession());
        context.dispatch(new CheckLocale());
        context.dispatch(new CheckSelectedUserApp());
    }
};
__decorate([
    Action(IsLoggedIn),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, IsLoggedIn]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "isLoggedIn", null);
__decorate([
    Action(IsLoggedInSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, IsLoggedInSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "isLoggedInSuccess", null);
__decorate([
    Action(IsLoggedInFailure),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, IsLoggedInFailure]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "isLoggedInFailure", null);
__decorate([
    Action(LoginWithBiodigital),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoginWithBiodigital]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "login", null);
__decorate([
    Action(LoginWithGoogle),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoginWithGoogle]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "loginWithGoogle", null);
__decorate([
    Action(LoginWithFacebook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoginWithFacebook]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "loginWithFacebook", null);
__decorate([
    Action(LoginSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LoginSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "loginSuccess", null);
__decorate([
    Action(Logout),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Logout]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "logout", null);
__decorate([
    Action(LogoutSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LogoutSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "logoutSuccess", null);
__decorate([
    Action(CheckProfile),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CheckProfile]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "checkProfile", null);
__decorate([
    Action(CheckProfileSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CheckProfileSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "checkProfileSuccess", null);
__decorate([
    Action(GetUserProfile),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetUserProfile]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "getUserProfile", null);
__decorate([
    Action(GetUserProfileSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetUserProfileSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "getUserProfileSuccess", null);
__decorate([
    Action(GetUserApps),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetUserApps]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "getUserApps", null);
__decorate([
    Action(SetUserApps),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetUserApps]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "setUserApps", null);
__decorate([
    Action(SetSelectedUserApp),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetSelectedUserApp]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "setSelectedUserApp", null);
__decorate([
    Action(CheckSelectedUserApp),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CheckSelectedUserApp]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "checkSelectedUserApp", null);
__decorate([
    Action(CheckSession),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CheckSession]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "checkSession", null);
__decorate([
    Action(GetEnvironmentSettings),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetEnvironmentSettings]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "getEnvironmentSettings", null);
__decorate([
    Action(GetEnvironmentSettingsSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetEnvironmentSettingsSuccess]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "GetEnvironmentSettingsSuccess", null);
__decorate([
    Action(ResetPassword),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetPassword]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "resetPassword", null);
__decorate([
    Action(SignUp),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SignUp]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "signUp", null);
__decorate([
    Action(SignUpFailure),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SignUpFailure]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "signUpFailure", null);
__decorate([
    Action(SetUserLocale),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetUserLocale]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "setUserLocale", null);
__decorate([
    Action(CheckLocale),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CheckLocale]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "checkLocale", null);
__decorate([
    Action(GetUserMessage),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetUserMessage]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "getUserMessage", null);
__decorate([
    Action(SetUserMessageViewed),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetUserMessageViewed]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "setUserMessageViewed", null);
__decorate([
    Action(ResetAuth),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetAuth]),
    __metadata("design:returntype", void 0)
], AuthState.prototype, "resetAuth", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getLoggedIn", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getEnvironmentSettings", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getUserProfile", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getProfileCheck", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getLoading", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getUserLocale", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", String)
], AuthState, "getUserLanguage", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getUserApps", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "getSelectedUserApp", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthStateModel]),
    __metadata("design:returntype", void 0)
], AuthState, "isPremiumUser", null);
AuthState = __decorate([
    State({
        name: 'auth',
        defaults: initialState
    }),
    __metadata("design:paramtypes", [AuthService,
        UserMessageService,
        StorageService, String, Store,
        ErrorService])
], AuthState);
export { AuthState };
